<template>
  <div class="role-bd bd">
    <div class="aside">
      <div class="title">
        <i class="icon icon-zuzhi"></i>
        <span>{{ $t('crm_groupRelation.ji_tuan_ke_hu') }}</span>
      </div>
      <div class="search">
        <div class="ub">
          <div class="ub-f1">
            <el-form>
              <el-form-item>
                <el-input :placeholder="$t('crm_groupRelation.jtkhmc')" v-model="formSearch.search" clearable>
                  <template slot="append">
                    <div @click="onCurrentPage(1)">
                      <i class="icon icon-search"></i>
                    </div>
                  </template>
                </el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="list">
        <el-tree
          ref="tree"
          :data="customerList"
          :props="treeProps"
          node-key="partnerId"
          :highlight-current="true"
          :expand-on-click-node="false"
          @node-click="handleNodeClick"
          :filter-node-method="filterNode"
        >
          <span v-if="data.partnerId === roleData.partnerId" class="tree-item" slot-scope="{ node, data}">
            <span class="line1" :title="data.partnerName">{{data.partnerName}}</span>
          </span>
          <span class="tree-item" v-else>
            <span class="line1" :title="data.partnerName">{{data.partnerName}}</span>
          </span>
        </el-tree>
        <div style="padding: 12px 0px; text-align: center">
          <el-pagination v-if="totalRows" :pager-count="5" small layout="prev, pager, next" :current-page="formSearch.pageNum" :page-size="formSearch.pageSize" :total="totalRows" @current-change="onCurrentPage">
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="section" style="padding: 0">
      <el-tabs v-model="activeTab">
        <el-tab-pane v-if="funcView.func_check_bind_rent_list" :label="$t('crm_groupRelation.glzlf')" name="tab1"></el-tab-pane>
        <el-tab-pane v-if="funcView.func_location_list" :label="$t('crm_groupRelation.xiang_mu')" name="tab2"></el-tab-pane>
        <el-tab-pane v-if="funcView.func_check_device_list" :label="$t('crm_groupRelation.she_bei')" name="tab3"></el-tab-pane>
      </el-tabs>
      <!-- 关联租赁方 -->
      <rent-hire  v-if="activeTab === 'tab1'" :roleData="roleData"></rent-hire>
      <!-- 项目 -->
      <rent-location v-if="activeTab === 'tab2'" :roleData="roleData"></rent-location>
      <!-- 设备 -->
      <rent-device v-if="activeTab === 'tab3'" :roleData="roleData"></rent-device>
    </div>

  </div>
</template>

<script>
import apis from '@/utils/apis';
import rentHire from './children/rent_hire.vue';
import rentDevice from './children/rent-device.vue';
import rentLocation from './children/rent_location.vue';

export default {
  name: 'groupRelation',
  components: { rentHire, rentDevice, rentLocation },
  data() {
    return {
      provide: true,
      activeTab: '',
      treeProps: {
        children: 'children',
        label: 'partnerName'
      },
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        // partnerType: 'CO' // 总部 HQ 售后公司SC 总代理 JV 大客户CO 租赁方CS
        childOrgType: 'CO' // 总部 HQ 售后公司SC 总代理 JV 大客户CO 租赁方CS
      },
      // 集团客户id
      groupCustomerId: '',
      groupCustomerName: '',

      totalRows: null,
      customerList: [],
      roleData: {},
      // appKey: '',
      partnerOrgId: '',
    };
  },
  watch: {
    // 监听路由变化
    '$route': {
      immediate: false,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.groupCustomerId = this.getJump('groupCustomerId');
          this.groupCustomerName = this.getJump('groupCustomerName');
          this.formSearch.search = this.groupCustomerName;
          this.getCustomerList();
        }
      }
    }
  },
  mounted() {
    // 获取id   有去获取详情 无就新增
    this.groupCustomerId = this.getJump('groupCustomerId');
    this.groupCustomerName = this.getJump('groupCustomerName');
    this.getCustomerList();
    this.getFuncView();
    this.activeTab = 'tab1';
  },
  methods: {
    // 获取岗位列表
    getCustomerList: function () {
      this.$getJSON(apis.partnerPage, this.formSearch).then((res) => {
        if (res.code === 0) {
          // console.log(res);
          this.customerList = res.data.list;
          this.totalRows = res.data.total;
          // if (!this.roleData.partnerId) {
          // 如果是跳转过来的
          if (this.groupCustomerId) {
            const item = this.customerList.find(i => i.partnerId === this.groupCustomerId);
            this.roleData = item || {};
          } else {
            this.roleData = this.customerList[0] ? this.customerList[0] : {};
          }

          // }
          this.$nextTick(() => {
            if (this.roleData.partnerId) {
              this.$refs.tree.setCurrentKey(this.roleData.partnerId);
            }
          });
        }
      });
    },
    // 选中角色项
    handleNodeClick: function (row) {
      this.roleData = row;

      this.partnerOrgId = row.partnerOrgId;
    },
    // 搜索过滤事件
    filterTree: function () {
      // this.$refs.tree.filter(this.appKey);

    },
    // 搜索过滤
    filterNode: function (value, data) {
      if (!value) {
        return true;
      }
      return data.partnerName.indexOf(value) !== -1;
    },
    // 切换页
    onCurrentPage: function (page) {
      this.formSearch.pageNum = page;
      this.getCustomerList();
    },
    // 切换每页数量
    onSizeChange: function (size) {
      this.formSearch.pageSize = size;
      this.getCustomerList();
    },
  }
};
</script>

<style lang="scss">
@import "../../../style/colors.scss";

.role-bd {
  .aside {
    .title {
      padding: 14px 10px 16px 12px;
      line-height: 24px;
      color: #404040;
      font-weight: bold;
      font-size: 16px;
      .icon {
        font-weight: normal;
        float: left;
        margin-right: 8px;
        font-size: 14px;
      }
    }
    .search {
      margin: 0 10px;
    }
    .is-current > .el-tree-node__content {
      background-color: $main-color;
      .tree-item {
        color: #ffffff;
        .icon {
          color: #ffffff;
          font-size: 12px;
        }
        .disable {
          color: #ffffff;
        }
      }
    }
    .tree-item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      padding-right: 8px;
      width: 0;
      .disable {
        color: #bfbfbf;
      }
    }
    .list{
      display: flex;
      flex-direction: column;
      .el-tree{
        flex: 1;
      }
      .el-pagination{
        height: 50px;
        flex: 0 0 50px;
      }
    }
  }
  .section {
    .el-tabs .el-tabs__item{
      font-size: 14px;
      color: #262626;
      font-weight: normal;
      line-height: 44px;
      height: 44px;
      &.is-active{
        font-weight: bold;
      }
    }
  }
}
</style>
